import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
    AccordionModule,
    TabViewModule,
    ListboxModule,
    DropdownModule,
    TreeTableModule,
    GrowlModule,
    ButtonModule
} from 'primeng/primeng';

import { SharedModule } from '../../shared/shared.module';
import { DashboardRoutingModule } from './dashboard-routing.module';
import {PowerBiReportContainerComponent } from './powerbi-report-container/powerbi-report-container.component';


import {  DashboardAPIService  } from  '../../services/Crestron.HydrogenAPI.DashboardTokenApi.service';
import { BusyModule } from 'angular2-busy/index'; //YH 12/6/2016 Add busy animation

//HTTP Request Tracking
import { Http, Response,RequestOptions, XHRBackend } from '@angular/http';

import {Injectable, Injector} from '@angular/core';

@NgModule({
    imports: [
        BusyModule, //YH 12/6/2016 Add busy animation

        AccordionModule,
        ButtonModule,
        DropdownModule,
        GrowlModule,
        ListboxModule,
        TabViewModule,
        TreeTableModule,

        SharedModule,
        DashboardRoutingModule
    ],
    declarations: [

    ],
    exports: [

    ],
    providers: [
      DashboardAPIService
    ]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/features/dashboard/dashboard.module.ts